export default __webpack_public_path__ + "static/media/icon-Hegic_full.548cf977.svg";